import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import {
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";

// PROJECT IMPORTS
import tableData from "../../../config/data/savings.json";
import { CSVLink } from "react-csv";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import appStatic from "../../../config/appStatic";
import appLabel from "../../../config/appLabel";
import StatusSelect from "../../../components/StatusSelect";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import DownloadTableButtons from "../../../components/DownloadTableButtons";

import { rightAction } from "../../../redux/actions";

const columns = [
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: "Office",
    dataIndex: "officeName",
    sorter: (a, b) => a.officeName.localeCompare(b.officeName),
  },
  {
    title: "Debit Tags",
    dataIndex: "debitTags",
  },
  {
    title: "Debit Account",
    dataIndex: "debitAccounts",
  },

  {
    title: "Credit Tags",
    dataIndex: "creditTags",
  },

  {
    title: "Credit Accounts",
    dataIndex: "creditAccounts",
  },
];

const GLA0500 = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [accountingRulesList, setAccountingRulesList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_ACCOUNTINGRULE") && getAccountingRulesListAction();
    // //DISABLE ALL RIGHTSIDEBAR ACTION
    // dispatch({
    //   type: cnt.CLEAR_RIGHT_BTN,
    // });
    BOM.HasPermission("CREATE_ACCOUNTINGRULE") &&
      rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getAccountingRulesListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetAccountingRulesList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            name: element?.name ? element?.name : "No Description",
            officeName: element?.officeName
              ? element?.officeName
              : "No Office Description",
            creditAccounts: element?.creditAccounts
              ? element?.creditAccounts.map(
                  (creditAccount) => creditAccount.name
                )
              : "-",
            debitAccounts: element?.debitAccounts
              ? element?.debitAccounts.map((debitAccount) => debitAccount.name)
              : "-",
            debitTags: element?.debitTags
              ? element?.debitTags.map((debitTag) =>
                  element?.debitTags[-1]
                    ? debitTag.tag.name
                    : debitTag.tag.name + ", "
                )
              : "-",
            creditTags: element?.creditTags
              ? element?.creditTags.map((creditTag) =>
                  element?.creditTags[-1]
                    ? creditTag.tag.name
                    : creditTag.tag.name + ", "
                )
              : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setAccountingRulesList(tempArray.filter((item) => item.disabled === false));
        setAccountingRulesList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(
        body,
        definedApi.GetAccountingRulesList,
        (err, res) => {
          if (err) {
            reject(err);
          } else {
            const objList = res;
            let tempArray = [];

            objList.forEach((element) => {
              tempArray.push({
                key: element?.id,
                name: element?.name ? element?.name : "No Description",
                officeName: element?.officeName
                  ? element?.officeName
                  : "No Office Description",
                creditAccounts: element?.creditAccounts
                  ? element?.creditAccounts.map(
                      (creditAccount) => creditAccount.name
                    )
                  : "-",
                debitAccounts: element?.debitAccounts
                  ? element?.debitAccounts.map(
                      (debitAccount) => debitAccount.name
                    )
                  : "-",
                debitTags: element?.debitTags
                  ? element?.debitTags.map((debitTag) =>
                      element?.debitTags[-1]
                        ? debitTag.tag.name
                        : debitTag.tag.name
                    )
                  : "-",
                creditTags: element?.creditTags
                  ? element?.creditTags.map((creditTag) =>
                      element?.creditTags[-1]
                        ? creditTag.tag.name
                        : creditTag.tag.name
                    )
                  : "-",
              });
            });

            resolve(tempArray);
          }
        }
      );
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    // console.log(selectedRowKeys);
    // console.log(objParam);

    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_ACCOUNTINGRULE") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_ACCOUNTINGRULE") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setAccountingRulesList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.name.toLowerCase()?.includes(searchKey)
    );
    setAccountingRulesList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-gla0500", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-gla0500", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-gla0500", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={appLabel.AccountingRules}
        pageItems={appStatic.AccountingRulesItems}
      />

      <Card
        title={`${appLabel.AccountingRules} List`}
        // extra={
        //   <Col>
        //     <StatusSelect handleStatusChange={null} />
        //   </Col>
        // }
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Record Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <DownloadTableButtons
              downloadData={accountingRulesList}
              columns={columns}
              fileName={"Accounting Rules List"}
              onExportClick={getCsvListData}
            /> */}
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={accountingRulesList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(GLA0500);
